module.exports = "/_next/static/images/exchange arrows-075ccd6743b3ad1df20511c3a42bb80e.svg";